import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { useState } from "react";

const GYP_LOGO = "/gyp-logo.png";

export default function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const navLinks = [
    { href: "/#about", label: "About" },
    { href: "/#programs", label: "Programs" },
    { href: "/#partners", label: "Partners" },
    { href: "/team", label: "Team" },
  ];

  return (
    <header 
      className="bg-white border-b border-black/10 sticky top-0 z-50"
      data-testid="header"
    >
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between h-20 px-6">
          {/* Logo */}
          <Link 
            to="/" 
            className="flex items-center gap-5"
            data-testid="header-logo"
          >
            <img
              src={GYP_LOGO}
              alt="GYP"
              className="h-12 w-12 object-contain logo-clean"
            />
            <div className="hidden sm:block">
              <span className="font-serif text-xl text-ink block leading-tight">
                Global Youth Platform
              </span>
              <span className="text-[10px] tracking-[0.25em] text-muted uppercase">
                International Organization
              </span>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-10">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className="text-sm tracking-wide text-slate hover:text-ink link-editorial transition-editorial"
                data-testid={`nav-${link.label.toLowerCase()}`}
              >
                {link.label}
              </a>
            ))}
            <a
              href="/#gallery"
              className="text-sm tracking-wide text-slate hover:text-ink link-editorial transition-editorial"
              data-testid="nav-gallery"
            >
              Gallery
            </a>
          </nav>

          {/* Desktop CTA */}
          <div className="hidden md:flex items-center gap-4">
            <Link 
              to="/partner"
              className="text-sm tracking-wide text-slate hover:text-ink link-editorial"
              data-testid="header-partner-btn"
            >
              Partner
            </Link>
            <Link to="/register">
              <button 
                className="bg-crimson hover:bg-[#6B130B] text-white px-6 py-3 text-xs tracking-[0.15em] uppercase font-medium transition-editorial"
                data-testid="header-apply-btn"
              >
                Apply Now
              </button>
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden p-2"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            data-testid="mobile-menu-btn"
          >
            {mobileMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden border-t border-black/10 px-6 py-6">
            <nav className="flex flex-col gap-4">
              {navLinks.map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  className="text-sm text-slate py-2"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  {link.label}
                </a>
              ))}
              <div className="pt-4 border-t border-black/10 flex flex-col gap-3">
                <Link to="/partner" onClick={() => setMobileMenuOpen(false)}>
                  <button className="w-full border border-black/15 text-ink px-6 py-3 text-xs tracking-[0.15em] uppercase">
                    Partner
                  </button>
                </Link>
                <Link to="/register" onClick={() => setMobileMenuOpen(false)}>
                  <button className="w-full bg-crimson text-white px-6 py-3 text-xs tracking-[0.15em] uppercase">
                    Apply Now
                  </button>
                </Link>
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}
